import { revokeCurrentStaffSession } from '../modules/auth/staffSession';
import styled, { useTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { CloseIcon } from '../assets/icons/close';
import { useAppDispatch } from '../store';
import { clearToken } from '../modules/auth/state/authSlice';
import { api } from '../api/api';
import { Label, LogoutPress, LogoutText, StyledLink } from './SideNav';
import { TurnOffIcon } from '../assets/icons/turnOff';
import { NavOptionType } from './Layout';
import { NewBadge } from './NewBadge';

type SideViewerProps = {
  isOpen: boolean;
  onToggle: () => void;
  navOptions: NavOptionType[];
};
export const SideViewer = ({ isOpen, onToggle, navOptions }: SideViewerProps) => {
  const { colors } = useTheme();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onLogoutPress = async () => {
    await revokeCurrentStaffSession();
    dispatch(clearToken());
    dispatch(api.util.resetApiState());
    navigate('/');
  };
  return (
    <Container isOpen={isOpen}>
      <TopWrapper>
        <CloseWrapper onClick={onToggle}>
          <CloseIcon />
        </CloseWrapper>

        {navOptions.map((navOption) => (
          <LinkerWrapper key={navOption.to}>
            <StyledLink
              to={navOption.to}
              onClick={onToggle}
              target={navOption.isExternal ? '_blank' : undefined}
              isActive={Boolean(navOption.isSelected)}>
              {navOption.icon}
              <Label isActive={Boolean(navOption.isSelected)}>{navOption.name}</Label>
              {navOption.isNew && <NewBadge size="small" />}
            </StyledLink>
          </LinkerWrapper>
        ))}
      </TopWrapper>

      <LinkerWrapper>
        <LogoutWrapper onClick={onLogoutPress}>
          <TurnOffIcon size={30} color={colors.red} />
          <LogoutText>Logout</LogoutText>
        </LogoutWrapper>
      </LinkerWrapper>
    </Container>
  );
};

const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const CloseWrapper = styled.button`
  align-self: flex-end;
  padding: 1rem;
`;

const Container = styled.div<{ isOpen: boolean }>`
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.gray};
  z-index: 10;
  flex-direction: column;
  justify-content: space-between;

  transition: 0.3s;
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(-100%)')};

  @media (max-width: 850px) {
    display: flex;
  }
`;

const LinkerWrapper = styled.div`
  padding: 0.5rem 2rem;
  position: relative;
`;

const LogoutWrapper = styled(LogoutPress)`
  text-align: center;
  align-self: flex-end;
  border: 1px solid ${({ theme }) => theme.colors.red};
  margin-bottom: 2rem;
`;
